import React from "react";
import { usePreguntasCalidad } from "../../hooks";
import { Preguntas } from "../Preguntas";
import usePreguntasPuntualidad from "../../hooks/usePreguntasPuntualidad";
import usePreguntasComunicacionReportes from "../../hooks/usePreguntasComunicacionReportes";
import usePreguntasResponsabilidadManejoVehiculo from "../../hooks/usePreguntasResponsabilidadManejoVehiculo";
import usePreguntasActitudTrabajoEquipo from "../../hooks/usePreguntasActitudTrabajoEquipo";
import usePreguntasProductividadEficiencia from "../../hooks/usePreguntasProductividadEficiencia";

const PreguntasProductividadEficiencia = () => {
	const { frmPreguntas, setPuntajeTotal } = usePreguntasProductividadEficiencia();

	return (
		<Preguntas
			form={frmPreguntas}
			calcularPuntajeTotal={setPuntajeTotal}
			titulo="Productividad y eficiencia (3/6)"
			opciones={[
				{ key: "cumpleTiemposEstimadosParaCadaTrabajoAsignado", label: "Cumple con los tiempos estimados para cada trabajo asignado" },
				{ key: "administraBienSuTiempo", label: "Administra bien su tiempo y evita tiempos muertos innecesarios" },
				{ key: "puedeTrabajarEnVariosProyectosSimultaneamente", label: "Puede trabajar en varios proyectos o reparaciones simultáneamente" },
				{ key: "manejaAdecuadamenteLaPresionEnAltaDemanda", label: "Maneja adecuadamente la presión en momentos de alta demanda" }
			]}
		/>
	);
};

export default PreguntasProductividadEficiencia;
